<template>
  <div class="tabForm">
    <div v-if="isTabExists">
      <v-tabs align-with-title v-model="currentTab">
        <v-tab v-for="tab in tabs" :key="tab.key">{{ tab.label }}</v-tab>
        <v-tab v-if="elements">Pension Elements</v-tab>
      </v-tabs>
      <v-tabs-items v-model="currentTab">
        <v-tab-item v-for="tab in tabs" :key="tab.key" eager>
          <v-row>
            <v-col
              v-for="container in tab.containers"
              :cols="container.columnWidth > 0 ? container.columnWidth : colsValue"
              :key="container.order"
              class="formColumn"
            >
              <FormPanel
                :formElements="container.formElements"
                :parentContainer="container.order"
                :readOnly="readOnly"
                :editDisabled="editDisabled"
              ></FormPanel>
            </v-col>
          </v-row>
        </v-tab-item>
        <v-tab-item v-if="elements">
          <PensionElements
            :pensionItems="elements"
            :currentPlanId="planId"
            :selectedMemberId="membershipId"
            :exitId="exitId"
            :isEditMode="!readOnly"
          />
        </v-tab-item>
      </v-tabs-items>
    </div>
    <div v-else>
      <v-row v-if="containers.length > 1">
        <v-col v-for="container in containers" :cols="colsValue" :key="container.order">
          <FormPanel
            :formElements="container.formElements"
            :parentContainer="container.order"
            :readOnly="readOnly"
            :editDisabled="editDisabled"
          ></FormPanel>
        </v-col>
      </v-row>
      <div v-else>
        <FormPanel
          :formElements="formElements"
          :readOnly="readOnly"
          :editDisabled="editDisabled"
        ></FormPanel>
      </div>
    </div>
  </div>
</template>

<script>
import FormPanel from '@/components/FormPanel.vue';
import PensionElements from '@/views/Members/Leavers/PensionElements.vue';
import Utils from '@/utils.js';

export default {
  name: 'TabForm',
  components: {
    FormPanel,
    PensionElements,
  },
  props: {
    formElements: { type: Array },
    readOnly: { type: Boolean, default: true },
    editDisabled: { type: Array },
    membershipId : { type: Number },
    planId : { type: Number },
    elements : { type: Array},
    exitId : { type:Number},
    defaultTabLabel: {type:String},
  },
  created: function () {
    this.processTabs();
  },
  data() {
    return {
      colWidth: 4,
      currentTab: 0,
      colsValue: 12,
      tabs: [],
    };
  },
  methods: {
    processTabs() {
      this.tabs = [];
      if (this.formElements) {
        const tabs = this.formElements.filter((x) => {
          return x.FieldType == 'Tab';
        });

        // Fake tab
        if (!tabs.length) {
          const zeroTab = { ...this.formElements[0] };
          for (let prop in zeroTab) {
            zeroTab[prop] = '';
          }
          zeroTab.FieldOrder = 1;
          zeroTab.FieldId = 'Tab0';
          zeroTab.Label = this.defaultTabLabel ? this.defaultTabLabel : 'zeroTab';
          tabs.push(zeroTab);
        }

        tabs.sort(Utils.dynamicSort('FieldOrder'));
        let maxColumnCount = 1;
        let statusHistory = false;
        tabs.forEach((tab) => {
          const tabModel = {
            key: tab.FieldId,
            label: tab.Label,
            containers: [],
          };
          const tabFormElements = this.formElements.filter((x) => {
            if (tab.FieldId === 'Tab0') return true;
            return x.ParentTab == tab.FieldId;
          });
          if (tabFormElements) {
            const groupFormElements = Utils.groupBy(tabFormElements, 'ParentContainer');
            Object.keys(groupFormElements).forEach((key) => {
              const containerFormElements = groupFormElements[key];
              const containerModel = {
                order: key,
                formElements: containerFormElements,
                columnWidth: 0,
              };
              if (containerFormElements.find((f) => f.FieldType === 'StatusHistory')){
                containerModel.columnWidth = 5;
                statusHistory = true;
              }
                
              tabModel.containers.push(containerModel);
            });
          }

          if (tabModel.containers && tabModel.containers.length > 1) {
            tabModel.containers.sort(Utils.dynamicSort('order'));
            let containerCount = tabModel.containers.length;
            if (statusHistory){containerCount += 1}
            maxColumnCount =
              containerCount > maxColumnCount
                ? containerCount
                : maxColumnCount;
            
          }

          this.tabs.push(tabModel);
        });
        this.colsValue = 12 / maxColumnCount;
        this.$emit('max_column', maxColumnCount);
      }
    },
  },
  computed: {
    isTabExists() {
      if (this.elements) return true;
      return this.tabs && this.tabs.length > 1;
    },
    containers() {
      if (this.tabs.length === 1) {
        return this.tabs[0].containers;
      }
      return [];
    },
  },
  watch: {
    formElements: function () {
      this.processTabs();
    },
  },
};
</script>

<style lang="scss" scoped></style>
